import { useHistory } from 'react-router-dom';
import { Task, TaskItem, ResponseReuseInfo } from '../interfaces';
import { ResponseReuseType, ResponseReuseRouteParam } from '../constants';
import { routeMappings } from '../../constants';
import { redirectUrlOnPartialResponseReuse } from '../utils/redirectUrlOnPartialResponseReuse';
import { getCookie } from '../../common/utils/cookies';

export const useResponseReuse = (tasks: Task[]): void => {
  let info;
  const history = useHistory();
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  if (!tcPlusFlow) return;

  const responseReused = sessionStorage.getItem('responseReuseInfo');
  if (responseReused) info = JSON.parse(responseReused);

  if (
    sessionStorage.getItem('userSessionActive') === 'false' ||
    (sessionStorage.getItem('responseReuseAcknowledged') && info.type !== ResponseReuseType.PARTIAL_RR)
  )
    return;

  if (info) {
    const url = redirectUrlOnPartialResponseReuse(info);
    if (url) {
      history.push(url);
      return;
    }
  }

  // CASE: Login at start
  let fullRRCount = 0;

  for (const task of tasks) {
    fullRRCount += task.responseReuseType === ResponseReuseType.FULL_RR ? 1 : 0;
  }

  if (tasks && fullRRCount === tasks.length) {
    // After Full RR, Redirect to End page
    const responseReuseInfo: ResponseReuseInfo = {
      type: ResponseReuseType.FULL_RR,
      url: `${routeMappings['INFO']}/${ResponseReuseRouteParam.COMPLETE_RR}`,
    };

    sessionStorage.setItem('responseReuseInfo', JSON.stringify(responseReuseInfo));

    // Redirect to Full RR page
    history.push(responseReuseInfo.url);
    return;
  }

  // CASE: Login before assessment
  const launchAssessmentConfig = sessionStorage.getItem('launchconfig');
  const parsedLaunchAssessmentConfig = launchAssessmentConfig && JSON.parse(launchAssessmentConfig);
  if (parsedLaunchAssessmentConfig) {
    let currentItem: TaskItem | undefined;
    tasks.forEach((task) => {
      if (!currentItem) currentItem = task.items.find((item) => item.itemId === parsedLaunchAssessmentConfig.itemId);
    });

    if (currentItem) {
      const currentItemState = currentItem.state && JSON.parse(currentItem.state);
      if (currentItemState.responseReuseType === ResponseReuseType.FULL_RR) {
        // After Full RR, Redirect to Task List page
        const responseReuseInfo: ResponseReuseInfo = {
          type: ResponseReuseType.FULL_RR,
          url: `${routeMappings['INFO']}/${ResponseReuseRouteParam.FULL_RR}`,
        };

        sessionStorage.setItem('responseReuseInfo', JSON.stringify(responseReuseInfo));

        // Redirect to Full RR page
        history.push(responseReuseInfo.url);
        return;
      } else if (currentItemState.responseReuseType === ResponseReuseType.PARTIAL_RR) {
        // Redirect to Partial RR page
        const responseReuseInfo: ResponseReuseInfo = {
          type: ResponseReuseType.PARTIAL_RR,
          url: `${routeMappings['INFO']}/${ResponseReuseRouteParam.PARTIAL_RR}`,
        };

        sessionStorage.setItem('responseReuseInfo', JSON.stringify(responseReuseInfo));

        // Redirect to Parital RR page
        history.push(responseReuseInfo.url);
        return;
      } else {
        // Launch Assessment
        history.push(
          `${routeMappings['TASK']}/${parsedLaunchAssessmentConfig.taskId}${routeMappings['EXPASSES']}/${parsedLaunchAssessmentConfig.itemId}`,
        );
        return;
      }
    }
  }
};
